import * as React from "react";
import type { SVGProps } from "react";
const SvgCompliance = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32 10.388c-11.936 0-21.612 9.676-21.612 21.612 0 11.936 9.676 21.612 21.612 21.612 11.936 0 21.612-9.676 21.612-21.612 0-11.936-9.676-21.612-21.612-21.612ZM8.402 32C8.402 18.968 18.968 8.402 32 8.402c13.033 0 23.598 10.566 23.598 23.598 0 13.033-10.565 23.598-23.598 23.598C18.968 55.598 8.402 45.033 8.402 32Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M43.407 22.002 28.844 36.538l-7.284-7.284-3.63 3.655 10.914 10.914 18.193-18.198L43.407 22Z"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M63.007 32c0 17.125-13.882 31.008-31.007 31.008S.992 49.125.992 32 14.875.993 32 .993 63.007 14.875 63.007 32ZM32 8.402C18.968 8.402 8.402 18.968 8.402 32c0 13.033 10.566 23.598 23.598 23.598 13.033 0 23.598-10.565 23.598-23.598C55.598 18.968 45.033 8.402 32 8.402Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32 1.985C15.422 1.985 1.984 15.423 1.984 32c0 16.577 13.438 30.015 30.014 30.015 16.577 0 30.015-13.438 30.015-30.015C62.014 15.424 48.576 1.985 32 1.985ZM-.002 32c0-17.673 14.327-32 32-32 17.674 0 32 14.327 32 32 0 17.673-14.326 32-32 32C14.326 64 0 49.674 0 32Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCompliance;
